import { rtkApi } from '../rtkApi';

interface GenerateRatifiedContractResponse {
  success: boolean;
  message: string;
  newContract: any;
}

interface SignContractRequest {
  contractId: string;
  name: string;
  signature: string;
}

interface SignContractResponse {
  success: boolean;
  message: string;
  contract: any;
}

export const contractRatificationApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    generateRatifiedContract: builder.mutation<
      GenerateRatifiedContractResponse,
      { contractId: string }
    >({
      query: ({ contractId }) => ({
        url: `/ratification/${contractId}/generate`,
        method: 'POST',
      }),
      invalidatesTags: ['Contract', 'AgreeableClause', 'Proposal'],
    }),

    signContractAsBuyer: builder.mutation<
      SignContractResponse,
      SignContractRequest
    >({
      query: ({ contractId, name, signature }) => ({
        url: `/ratification/${contractId}/buyer-sign`,
        method: 'POST',
        data: { signedName: name, signature },
      }),
      invalidatesTags: ['Contract'],
    }),

    signContractAsSeller: builder.mutation<
      SignContractResponse,
      SignContractRequest
    >({
      query: ({ contractId, name, signature }) => ({
        url: `/ratification/${contractId}/seller-sign`,
        method: 'POST',
        data: { signedName: name, signature },
      }),
      invalidatesTags: ['Contract'],
    }),

    setPartySigners: builder.mutation<
      SignContractResponse,
      {
        contractId: string;
        signers: Array<{
          role?: string;
          name: string;
          email?: string;
          title?: string;
          order?: number;
        }>;
      }
    >({
      query: ({ contractId, signers }) => ({
        url: `/ratification/${contractId}/party-signers`,
        method: 'PUT',
        data: { signers },
      }),
      invalidatesTags: ['Contract'],
    }),

    signAsPartySigner: builder.mutation<
      SignContractResponse,
      {
        contractId: string;
        signerIndex: number;
        name: string;
        signature: string;
      }
    >({
      query: ({ contractId, signerIndex, name, signature }) => ({
        url: `/ratification/${contractId}/party-signers/${signerIndex}/sign`,
        method: 'POST',
        data: { signedName: name, signature },
      }),
      invalidatesTags: ['Contract'],
    }),
  }),
});

export const {
  useGenerateRatifiedContractMutation,
  useSignContractAsBuyerMutation,
  useSignContractAsSellerMutation,
  useSetPartySignersMutation,
  useSignAsPartySignerMutation,
} = contractRatificationApi;
